module.exports = "<div class=\"col-sm-10 col-md-10 main\">\n\t\t\t\t<h1 class=\"page-header\">Open FX Order Recommendations\n\t\t\t\t\t<button id=\"cancelAll\" type=\"button\" class=\"btn btn-default\" style=\"float: right; margin-top: -5px\">Cancel All</button>\n\t\t\t\t</h1>\n\t\t\t\t<div id='jqxWidget' style=\"font-size: 13px; font-family: Verdana; float: left; width: 100%; height: 50%;\">\n\t\t\t\t\t<div id=\"jqxGrid\"></div>\n\t\t\t\t</div>\n\t\t\t</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/wiserisk-core/src/main/ng4app/src/app/pages/orders/openfx/openfx.component.html
// module id = ../../../../../src/app/pages/orders/openfx/openfx.component.html
// module chunks = main